import React from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash.get';
import Link from 'components/Link';
import Image from 'components/Image';
import { checkJarvisIsAdActive } from 'helpers/ads/utils';
import AdCaller from 'helpers/ads/adCaller';
import s from './Masthead.scss';

/**
 * Masthead Component for the Desktop Website
 * This will be have the provision to handle the masthead innovation as well.
 * In site_settings.cms need the URL for the <image> to be served and innovation boolean flag.
 */
class Masthead extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      config: this.props.config,
      leaderboard: null,
    };
  }
  componentDidMount() {
    this.isAdVisible();
    this.checkAndUpdateMastheadFrame();
  }

  isAdVisible = () => {
    const jarvisSetting = checkJarvisIsAdActive('leaderboard');
    if (jarvisSetting) {
      const ad = {
        adName: 'leaderboard',
        adType: 'dfp',
        tn: 'ad',
      };
      this.setState({
        leaderboard: {
          ...ad,
          ...jarvisSetting,
        },
      });
    }
  };
  checkAndUpdateMastheadFrame = () => {
    const { config } = this.state;
    const { hideLogoMastHead } = this.props;
    if (!hideLogoMastHead && config.timeout > 0) {
      let newobj = {};
      if (config.settledFrame && _get(config, 'settledFrame.data.src')) {
        newobj = config.settledFrame;
      }
      setTimeout(() => {
        this.setState(
          {
            config: newobj,
          },
          this.checkAndUpdateMastheadFrame,
        );
      }, config.timeout);
    }
  };

  render() {
    const {
      colorTheme = '',
      videomasthead,
      poweredBy,
      hideLogoMastHead,
      isPrime,
      mastheadImageLogo,
      className,
      newHeader,
      isTechnology,
      isPrimeUserLayout,
      isReviewsPage,
    } = this.props; //default value to be '' as this is going to be assigned later on
    const { leaderboard } = this.state;
    const { type, data } = this.state.config;
    let { link, innovation } = this.state.config;
    if (hideLogoMastHead) {
      innovation = false;
      link = '';
    }

    let imageLogoId = colorTheme ? '79638690' : '73729958';
    if (mastheadImageLogo) {
      imageLogoId = mastheadImageLogo;
    }

    if (isPrimeUserLayout && !mastheadImageLogo) {
      imageLogoId = '92222747';
    }
    let logoWrapper = '';
    let headerLink = isTechnology
      ? `https://timesofindia.indiatimes.com/technology`
      : link || this.props.TOILogoUrl;
    if (isReviewsPage) {
      logoWrapper = s.largeLogo;
      imageLogoId = '113492625';
      headerLink = '/';
    }

    const src =
      (innovation && data && _get(data, 'src', undefined)) ||
      `https://static.toiimg.com/photo/${imageLogoId}.cms`;

    // old toi logo : 77144633
    const theme = s[colorTheme] || colorTheme;

    if (videomasthead && videomasthead.adCode) {
      return (
        <div
          id="header-masthead"
          className={`${s.masthead} ${className} ${theme} ${s[type] || ''}`} //type === 'toiLogo' ? s.toiLogo : ''
        >
          <div className="contentwrapper">
            <AdCaller data={videomasthead} className={s.videomasthead} />
          </div>
        </div>
      );
    }

    if (leaderboard && !isPrime) {
      return (
        <div
          id="header-masthead"
          className={`${s.masthead} ${className} ${theme}`} //type === 'toiLogo' ? s.toiLogo : ''
        >
          <div className="contentwrapper">
            <div className={s.mastheadAds}>
              <div className={s.left}>
                {type === 'toiLogo' && (
                  <>
                    <Link to={link || this.props.TOILogoUrl}>
                      {!newHeader && (
                        <img
                          src="https://static.toiimg.com/photo/77144633.cms"
                          alt="The Times Of India"
                        />
                      )}
                    </Link>
                  </>
                )}
              </div>
              <AdCaller data={leaderboard} className={s.right} immediateLoad />
            </div>
          </div>
        </div>
      );
    }

    let linkAttr = {};
    if (innovation && link) {
      linkAttr = {
        target: '_blank',
      };
    }
    return (
      <div
        id="header-masthead"
        className={`${s.masthead} ${className} ${theme} ${s[type] || ''}
          ${isPrimeUserLayout ? s.primelayout : ''} ${
          isPrimeUserLayout && innovation ? s.innovationHeader : ''
        }`} //type === 'toiLogo' ? s.toiLogo : ''
      >
        <div className="contentwrapper">
          {!isPrime && (
            <AdCaller
              data={{
                jname: 'earPlugAdsLeft',
              }}
              className={s.earplugLeft}
            />
          )}
          {type === 'toiLogo' && (
            <>
              <Link
                to={headerLink}
                {...linkAttr}
                aria-label={
                  isTechnology
                    ? 'Gadgets Now by The Times of India'
                    : 'TOI Logo'
                }
                className={`${
                  isPrimeUserLayout ? s.primelayout : ''
                } ${logoWrapper}`}
              >
                {!newHeader && !isTechnology && <Image src={src} />}

                {isTechnology && (
                  <figure className={s.gnLogo}>
                    <Image
                      src="https://static.toiimg.com/photo/109343604.cms"
                      alt="Gadgets Now by The Times of India"
                    />
                  </figure>
                )}
              </Link>
            </>
          )}
          {poweredBy && <div className={s.poweredby}>{poweredBy}</div>}
          {!isPrime && (
            <AdCaller
              data={{
                jname: 'earPlugAdsRight',
              }}
              className={s.earplugRight}
            />
          )}
        </div>
      </div>
    );
  }
}

Masthead.propTypes = {
  config: PropTypes.shape({
    innovation: PropTypes.bool,
    type: PropTypes.string,
    link: PropTypes.string,
    colorTheme: PropTypes.string,
    data: PropTypes.shape({}),
  }).isRequired,
  videomasthead: PropTypes.shape({}),
  colorTheme: PropTypes.string,
  poweredBy: PropTypes.string,
  leaderboard: PropTypes.shape({}),
  earplugAdsRight: PropTypes.shape({
    adCode: PropTypes.string,
    allowedcounteries: PropTypes.arrayOf(PropTypes.string),
  }),
  earplugAdsLeft: PropTypes.shape({
    adCode: PropTypes.string,
    allowedcounteries: PropTypes.arrayOf(PropTypes.string),
  }),
  hideLogoMastHead: PropTypes.bool,
  isPrime: PropTypes.bool,
  TOILogoUrl: PropTypes.string,
  mastheadImageLogo: PropTypes.string,
  className: PropTypes.string,
  newHeader: PropTypes.bool,
  isTechnology: PropTypes.bool,
  isPrimeUserLayout: PropTypes.bool,
};

Masthead.defaultProps = {
  colorTheme: '',
  videomasthead: undefined,
  earplugAdsRight: undefined,
  earplugAdsLeft: undefined,
  leaderboard: undefined,
  poweredBy: '',
  hideLogoMastHead: false,
  isPrime: false,
  TOILogoUrl: '/',
  mastheadImageLogo: '',
  className: '',
  newHeader: false,
  isTechnology: false,
  isPrimeUserLayout: false,
};

export default Masthead;
